<button
  type="button"
  class="btn btn-default btn-sm p-0 browse-button font-browser-button"
  [class.font-browser-button]="iconOnly()"
  title="Browse fonts"
  (click)="openFontBrowser()"
  [disabled]="disabled()">
  <i [class]="defaultIcon()"></i> {{ !iconOnly() ? 'Fonts' : '' }}
</button>

<ng-template #browserModal let-modal>
  <app-iframe-modal-shell
    [src]="browserUrl"
    [dismissLoadingOnLoad]="true"
    initialTitle="Font browser"
    (close)="modal.dismiss('cancel')">
  </app-iframe-modal-shell>
</ng-template>

<ng-template #nestedFileModal let-modal>
  <app-iframe-modal-shell
    [src]="nestedFileUrl"
    [dismissLoadingOnLoad]="true"
    initialTitle="File browser"
    (close)="modal.dismiss('cancel')">
  </app-iframe-modal-shell>
</ng-template>
